import Request from './request';

async function addJob(data) {
    return Request('post', "api/kingdee-worker/add-job", data);
}

export default {
    addJob,
};